import "./AddTransport.css";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import AddTransportViewModel from "./AddTransportViewModel";
import ButtonSpinner from "../../../../Components/Spinners/ButtonSpinner";
import IsSchoolAdded from "../../../../Hooks/IsSchoolAdded";
import PhoneInput from "react-phone-number-input";

const AddTransport = () => {
  const {
    RegisterTransport,
    AddTransport,
    setAddTransport,
    ContactNo,
    HandleContactNumberFormat,
    RouteNameError,
    VehicleNumberError,
    DriverNameError,
    ContactNumberError,
    DriverAddressError,
    FormDisabled,
    IsUpdate,
  } = AddTransportViewModel();
  const SchoolAddedResp = IsSchoolAdded();
  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper admin-add-transport-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">
                  {IsUpdate === true ? "Update Transport" : "Add Transport"}
                </h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`/user/admin/transport`}>Transports</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    {IsUpdate === true ? "Update Transport" : "Add Transport"}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-12">
                        <h5 className="form-title">
                          <span>Transport Information</span>
                        </h5>
                        {!SchoolAddedResp && (
                          <div className="add-school-first-container">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              className="bi bi-exclamation-triangle-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                            </svg>
                            <p>Please add school first!</p>
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Route Name <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              RouteNameError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddTransport({
                                ...AddTransport,
                                RouteName: e.target.value,
                              });
                            }}
                            value={AddTransport.RouteName}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {RouteNameError === true ? (
                            <span className="admin-add-transport-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Route name is required and cannot be less than 3
                                characters.
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-transport-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Route name is required and cannot be less than 3
                                characters.
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Vehicle Number{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              VehicleNumberError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddTransport({
                                ...AddTransport,
                                VehicleNumber: e.target.value,
                              });
                            }}
                            value={AddTransport.VehicleNumber}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {VehicleNumberError === true ? (
                            <span className="admin-add-transport-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Vehicle number is required.
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-transport-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Vehicle number is required.
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Driver Name <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              DriverNameError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddTransport({
                                ...AddTransport,
                                DriverName: e.target.value,
                              });
                            }}
                            value={AddTransport.DriverName}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {DriverNameError === true ? (
                            <span className="admin-add-transport-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Driver name is required and cannot be less than
                                3 characters.
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-transport-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Driver name is required and cannot be less than
                                3 characters.
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>License Number</label>
                          <input
                            className="form-control"
                            type="text"
                            onChange={(e) => {
                              setAddTransport({
                                ...AddTransport,
                                DriverLicense: e.target.value,
                              });
                            }}
                            value={AddTransport.DriverLicense}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Contact Number{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <PhoneInput
                            country="PK"
                            addInternationalOption={true}
                            defaultCountry="PK"
                            className={`form-control phone-input ${
                              ContactNumberError === true && "error-message"
                            }`}
                            countryCallingCodeEditable={true}
                            initialValueFormat="national"
                            onChange={(e) => {
                              // HandleContactNumberFormat(e);
                              setAddTransport({
                                ...AddTransport,
                                ContactNumber: e,
                              });
                            }}
                            value={AddTransport.ContactNumber}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {/* <input
                            className={`form-control ${
                              ContactNumberError === true && "error-message"
                            }`}
                            type="number"
                            onChange={(e) => {
                              // HandleContactNumberFormat(e);
                              setAddTransport({
                                ...AddTransport,
                                ContactNumber: e.target.value.slice(0, 11),
                              });
                            }}
                            // value={ContactNo}
                            value={AddTransport.ContactNumber}
                            disabled={FormDisabled || !SchoolAddedResp}
                          /> */}
                          {ContactNumberError === true ? (
                            <span className="admin-add-transport-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Driver contact number is required. 03069578963
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-transport-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Driver contact number is required. 03069578963
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Driver Address{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              DriverAddressError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddTransport({
                                ...AddTransport,
                                DriverAddress: e.target.value,
                              });
                            }}
                            value={AddTransport.DriverAddress}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {DriverAddressError === true ? (
                            <span className="admin-add-transport-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Driver address is required and cannot be less
                                than 3 characters.
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-transport-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Driver address is required and cannot be less
                                than 3 characters.
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="student-submit">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            onClick={(e) => {
                              e.preventDefault();
                              RegisterTransport();
                            }}
                            disabled={FormDisabled || !SchoolAddedResp}
                          >
                            {FormDisabled && <ButtonSpinner />}{" "}
                            {IsUpdate === true ? "Update " : "Submit"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default AddTransport;
